<template>
  <a v-if="$store.getters['configuration/crmCallPhonePath']" :href="$store.getters['configuration/crmCallPhonePath'].replace('%phoneNumber%', phoneNumber)" target="_blank">{{ phoneNumber }}</a>
  <span v-else>{{ phoneNumber }}</span>
</template>
<script>
export default {
  name: 'phoneNumberLink',
  props: {
    phoneNumber: {}
  }
}
</script>
